import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  contentWrapper,
  headerRow,
  hidden,
  icon,
  visible,
  windowHeader,
  windowHeaderClose,
  windowHeaderOpen,
  windowWrapper,
} from './floatingWindow.css';
import {
  faChevronUp,
  faClose,
  faExpand,
} from '@fortawesome/pro-regular-svg-icons';
import { Typography } from '../typography/typography';
import { clsx } from 'clsx';
import { sprinkles } from '@design-system/sprinkles.css';

export type FloatingWindowprops = {
  title: string;
  detailsLeft?: string;
  detailsRight?: string;
  className?: string;
  open: boolean;
  toggle: (isOpen: boolean) => void;
  expandContent?: boolean;
};

export const FloatingWindow = (
  p: React.PropsWithChildren<FloatingWindowprops>,
) => {
  if (!p.open && !p.expandContent) {
    return null;
  }
  return (
    <div
      className={clsx(windowWrapper, p?.className)}
      data-testid="floatingWindow"
      onClick={() => p.toggle(false)}
    >
      <div
        className={clsx(
          windowHeader,
          p.open ? windowHeaderOpen : windowHeaderClose,
        )}
      >
        <div className={headerRow}>
          <Typography
            variant="body"
            size="medium"
            className={clsx(sprinkles({ width: '100%' }))}
          >
            {p.title}
          </Typography>
          <FontAwesomeIcon
            className={icon}
            icon={
              p.expandContent
                ? p.open
                  ? faClose
                  : faChevronUp
                : p.open
                ? faExpand
                : faClose
            }
          />
        </div>
        <div className={headerRow}>
          {p?.detailsLeft ? (
            <Typography
              variant="body"
              size="small"
              className={clsx(sprinkles({ width: '100%' }))}
            >
              {p.detailsLeft}
            </Typography>
          ) : null}
          {p?.detailsRight ? (
            <Typography
              variant="body"
              size="small"
              className={clsx(sprinkles({ width: '100%', textAlign: 'right' }))}
            >
              {p.detailsRight}
            </Typography>
          ) : null}
        </div>
      </div>
      {p?.children ? (
        <div className={clsx(contentWrapper, p.open ? visible : hidden)}>
          {p.children}
        </div>
      ) : null}
    </div>
  );
};
